import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { cloneDeep, set } from 'lodash'

import InputTextField from '../../fields/inputtextfield/InputTextField'
import InputDateField from '../../fields/inputdatefield/InputDateField'
import InputNumberField from '../../fields/inputnumberfield/InputNumberField'
import { getErrorMessageForFormField } from '../../../utils/formUtils'

export default class AdministrativeInfoForm extends PureComponent {
  static propTypes = {
    administrativeInfo: PropTypes.object.isRequired,
    errors: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    readOnly: PropTypes.bool.isRequired
  }

  render() {
    const { readOnly } = this.props
    return (
      <div className="detail-view-section">
        <h1>Administrative information</h1>

        <div className="detailview double-view">
          <InputTextField
            name={'Order number'}
            fieldName={'orderNumber'}
            fieldValue={this.props.administrativeInfo.orderNumber}
            required={false}
            error={getErrorMessageForFormField(this.props.errors, 'orderNumber')}
            onChange={this.handleChange}
            readOnly={readOnly}
          />
          <InputTextField
            name={'Invoice number'}
            fieldName={'invoiceNumber'}
            fieldValue={this.props.administrativeInfo.invoiceNumber}
            required={false}
            error={getErrorMessageForFormField(this.props.errors, 'invoiceNumber')}
            onChange={this.handleChange}
            readOnly={readOnly}
          />
        </div>

        <div className="detailview double-view">
          <InputTextField
            name={'Customer'}
            fieldName={'customer'}
            fieldValue={this.props.administrativeInfo.customer}
            required={false}
            error={getErrorMessageForFormField(this.props.errors, 'customer')}
            onChange={this.handleChange}
            readOnly={readOnly}
          />
          <InputTextField
            name={'Broker'}
            fieldName={'broker'}
            fieldValue={this.props.administrativeInfo.broker}
            required={false}
            error={getErrorMessageForFormField(this.props.errors, 'broker')}
            onChange={this.handleChange}
            readOnly={readOnly}
          />
        </div>

        <div className="detailview double-view">
          <InputTextField
            name={'Inventory transfer number'}
            fieldName={'inventoryTransferNumber'}
            fieldValue={this.props.administrativeInfo.inventoryTransferNumber}
            required={false}
            error={getErrorMessageForFormField(this.props.errors, 'inventoryTransferNumber')}
            onChange={this.handleChange}
            readOnly={readOnly}
          />
          <InputNumberField
            name={'Freight (€)'}
            fieldName={'freight'}
            fieldValue={this.props.administrativeInfo.freight}
            required={false}
            error={getErrorMessageForFormField(this.props.errors, 'freight')}
            onChange={this.handleChange}
            step={0.01}
            readOnly={readOnly}
          />
        </div>

        <div className="detailview double-view">
          <InputDateField
            name={'Delivery date'}
            fieldName={'deliveryDate'}
            fieldValue={this.props.administrativeInfo.deliveryDate}
            required={false}
            error={getErrorMessageForFormField(this.props.errors, 'deliveryDate')}
            onChange={this.handleChange}
            pickerDisplayTop
            readOnly={readOnly}
          />
          <InputDateField
            name={'B/L date'}
            fieldName={'billOfLadingDate'}
            fieldValue={this.props.administrativeInfo.billOfLadingDate}
            required={false}
            error={getErrorMessageForFormField(this.props.errors, 'billOfLadingDate')}
            onChange={this.handleChange}
            pickerDisplayTop
            readOnly={readOnly}
          />
        </div>

        <div className="detailview double-view">
          <InputTextField
            name={'Loading surveyor'}
            fieldName={'loadingSurveyor'}
            fieldValue={this.props.administrativeInfo.loadingSurveyor}
            required={false}
            error={getErrorMessageForFormField(this.props.errors, 'loadingSurveyor')}
            onChange={this.handleChange}
            readOnly={readOnly}
          />

          <InputTextField
            name={'Discharge surveyor'}
            fieldName={'dischargeSurveyor'}
            fieldValue={this.props.administrativeInfo.dischargeSurveyor}
            required={false}
            error={getErrorMessageForFormField(this.props.errors, 'dischargeSurveyor')}
            onChange={this.handleChange}
            readOnly={readOnly}
          />
        </div>

        <div className="detailview">
          <InputTextField
            name={'Comment'}
            fieldName={'comment'}
            fieldValue={this.props.administrativeInfo.comment}
            required={false}
            error={getErrorMessageForFormField(this.props.errors, 'comment')}
            onChange={this.handleChange}
            readOnly={readOnly}
          />
        </div>
      </div>
    )
  }

  /**
   * When the value of a form input field changes
   */
  handleChange = (value, field) => {
    const updatedAdministrativeInfo = cloneDeep(this.props.administrativeInfo)
    set(updatedAdministrativeInfo, field, value)
    this.props.onChange(updatedAdministrativeInfo)
  }
}
